"use client"
/* */
const locales = {"de-DE": {  "contextualHelpButton.moreInformation": `Weitere Informationen`,
},"en-US": {  "contextualHelpButton.moreInformation": `More information`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@df0c8534e2e4f7c6c3d4365218df7347.mjs.map
